import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M853,1600 C470.706667,1600 159.666667,1288.96 159.666667,906.666667 C159.666667,524.373333 470.706667,213.333333 853,213.333333 C1235.29333,213.333333 1546.33333,524.373333 1546.33333,906.666667 C1546.33333,1288.96 1235.29333,1600 853,1600 L853,1600 Z M1850.76,1828.90667 L1454.38667,1432.64 C1577.58667,1291.73333 1653,1108.16 1653,906.666667 C1653,465.493333 1294.17333,106.666667 853,106.666667 C411.826667,106.666667 53,465.493333 53,906.666667 C53,1347.84 411.826667,1706.66667 853,1706.66667 C1054.38667,1706.66667 1238.17333,1631.25333 1378.97333,1508.05333 L1775.24,1904.42667 L1850.76,1828.90667 Z M479.666667,960.053333 L1226.33333,960.053333 L1226.33333,853.386667 L479.666667,853.386667 L479.666667,960.053333 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconZoomOutLine = /*#__PURE__*/function (_Component) {
  _inherits(IconZoomOutLine, _Component);

  var _super = _createSuper(IconZoomOutLine);

  function IconZoomOutLine() {
    _classCallCheck(this, IconZoomOutLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconZoomOutLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconZoomOut",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconZoomOutLine.displayName = "IconZoomOutLine";
  return IconZoomOutLine;
}(Component);

IconZoomOutLine.glyphName = 'zoom-out';
IconZoomOutLine.variant = 'Line';
IconZoomOutLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconZoomOutLine;
export { IconZoomOutLine };